import React, {useContext, useEffect, useMemo, useRef} from 'react';
import {PlayerContext} from "../../../shared/contexts/playerContext";
import {useNavigate} from "react-router-dom";
import TablePage from "../../../pages/tablePage/TablePage";
import {AuthContext} from "../../../shared/contexts/authContext";
import {useItemKrTextData} from "../../probability/useItemData";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import {getCouponLogColumns} from "../../logs/columns/couponLogColumns";

const CouponUse = () => {
    const { playerData } = useContext(PlayerContext);
    const { currentUser } = useContext(AuthContext);
    const navigate = useNavigate();

    const refreshRef = useRef(null);
    const { data: krItemTextData, isLoading, error } = useItemKrTextData();

    useEffect(() => {
        if (!playerData.userKey) {
            navigate('/player');
        }
    }, [playerData, navigate]);

    const columns = useMemo(() => getCouponLogColumns(krItemTextData, currentUser), [krItemTextData, currentUser]);

    const props = {
        columns,
        refreshRef,
        url: `player/couponUse?userKey=${playerData.userKey}`
    }

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;

    return (
            <TablePage {...props} />
    );
};

export default CouponUse;